export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/saleIcon.f3d670d7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};